// Escape a string for safe interpolation into innerHTML. Uses the browser's own
// text-node encoding (the same approach as the inline escapeHtml helpers in
// event_tags_controller / widget_configurator_controller). Returns "" for
// null/undefined.
export function escapeHtml(value) {
  if (value == null) return "";
  const div = document.createElement("div");
  div.textContent = String(value);
  return div.innerHTML;
}
